// HashtagIndex.js
import { connect } from 'react-redux';

import { HASHTAG_CATEGORIES } from '../RemoteConfigKeys.js';

import HashtagIndex from '../component/HashtagIndex.jsx';

import fetchTranslationByKey from '../action/fetchTranslationByKey.js';

import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const mapStateToProps = state => {
  return {
    meId: getMeData(state, 'id'),
    hashtagCategories: getRemoteConfigData(state, HASHTAG_CATEGORIES),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchTranslationByKey: ({ groups }) =>
      dispatch(fetchTranslationByKey({ groups })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HashtagIndex);
